module.exports = __webpack_public_path__ + "img/female-infant-figure.887c7782.svg";